import React from 'react'
import { Blocks } from "react-loader-spinner";

export const LoaderES = () => {
  return (
    <div className="abs-center">
          <Blocks
            visible={true}
            height="80"
            width="80"
            ariaLabel="blocks-loading"
            wrapperStyle={{}}
            wrapperClass="blocks-wrapper"
          />
        </div>
  )
}
